<p-toast></p-toast>
<div class="main-grid">
    <div class="picture-container">
        <div *ngIf="loadingStudentPicture" class="picture-loading-container">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE"
                animationDuration=".8s"></p-progressSpinner>
            <p>
                Picture loading... ⌛
            </p>
        </div>
        <div *ngIf="pictureUploading" class="picture-loading-container">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE"
                animationDuration=".8s"></p-progressSpinner>
            <p>
                Picture uploading... ⌛
            </p>
        </div>
        <p *ngIf="!loadingStudentPicture && bookingBrugesService.hasNoPicture && !pictureUploading">This booking has no picture</p>
        <canvas #myCanvas height="0" width="0"></canvas>
    </div>
    <div *ngIf="userService.hasAnyRole(['admin', 'editor'])">
        <input type="file" id="file" accept="image/*" (change)="handleFileInput($event)">
        <p-button *ngIf="!pictureLoaded" (onClick)="uploadFile()" label="Upload new picture" [disabled]="loadingStudentPicture"></p-button>
        <p-button *ngIf="pictureLoaded" (onClick)="updateFile()" label="Update picture" [disabled]="loadingStudentPicture"></p-button>
    </div>
    <div class="link-text-container">
        <p>
            Link for client dashboard:
        </p>
    </div>
    <div class="dashboard-link-container">
        <p>
            {{dashboardUrl}}
        </p>
    </div>
    <div class="vademecum-link-text">
        <p>
            Link for this student's vademecum:
        </p>
    </div>
    <div class="vademecum-link-container">
        <p-button label="Formulaire" routerLink="/student-informations/{{bookingService.booking.uuid}}"></p-button>
    </div>
    <div class="vademecum-status">
        <p>
            Status:
        </p>
    </div>
    <div class="vademecum-sent-information">
        <div *ngIf="booking.vademecum">
            <p>This booking has vademecum.</p>
            <p-button label="Download" (onClick)="downloadPdf(booking)"></p-button>
        </div>

        <div *ngIf="!booking.vademecum">
            <p>This booking has no vademecum.</p>
        </div>
    </div>
</div>